import jwtDecode from 'jwt-decode';

const TOKEN_NAME = 'id_token';

export default {
  get: () => {
    const store = localStorage.getItem(TOKEN_NAME);
    if (!store) {
      return { name: '', company: {} };
    } else {
      return jwtDecode(store);
    }
  },
  set: token => {
    localStorage.setItem(TOKEN_NAME, token);
  }
};